<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m20.5 7.97-9.55-7A5 5 0 0 0 3 5v14a5 5 0 0 0 7.96 4.03l9.54-7a5 5 0 0 0 0-8.06m-1.19 6.45-9.54 7A3 3 0 0 1 5 19V5a3 3 0 0 1 1.64-2.67A3 3 0 0 1 8.01 2a3 3 0 0 1 1.76.59l9.54 7a3 3 0 0 1 0 4.84Z"/></svg>
</template>
